import { Box, ThemeProvider } from '@mui/material'
import { C1Theme } from 'c1ui'
import { FC, ReactNode } from 'react'
import { LoginHeader } from './LoginHeader'

interface LoginLayoutProps {
    children: ReactNode
}

export const LoginLayout: FC<LoginLayoutProps> = ({ children }) => (
    <ThemeProvider theme={C1Theme}>
        <Box sx={{
            height: '100vh',
            width: '100vw',
            overflow: 'hidden',
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundImage: 'url(/static/login/login-bg.svg)',
            backgroundColor: '#F2F7FD',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: -1,
        }}
        />

        <Box sx={{
            height: '100vh',
            width: '100vw',
            overflow: 'auto',
            position: 'relative',
        }}
        >
            <LoginHeader />

            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'calc(100vh - 64px)',
                pt: '50px',
                pb: 2,
            }}
            >
                {children}
            </Box>
        </Box>
    </ThemeProvider>
)
